
import { useState, useEffect } from 'react';

import { Spinner } from "react-bootstrap";
import Form from 'react-bootstrap/Form';
import FormControl from '@mui/material/FormControl';
import TeamInsightRG_MLB from './TeamInsightRG_MLB';
import WLoptions from './WLoptions';
import WLTable from './WLtable';
import WLChart from './WLChart';
import PickPropCard from './PickPropCard';

import useGoogleCharts from '../hooks/useGoogleCharts';

const MLBTeamPage = ({ sportcode, teamid }) => {

    const google = useGoogleCharts('corechart');

    const getCurrentYear = new Date().getFullYear()

    const [teams, setTeams] = useState([teamid]);
    const [opps, setOpps] = useState([]);
    const [seasons, setSeasons] = useState([getCurrentYear.toString()]);
    const [loading, setLoading] = useState(true);
    const [teamOptions, setTeamOptions] = useState([]);
    const [teamName, setTeamName] = useState('');
    const [srid, setSrid] = useState('')
    const [selTeam, setSelTeam] = useState([])

    const [projedtedWins, setProjectedWins] = useState(0)

    const [location, setLocation] = useState("All")

    const onTeamChange = (event) => {
        
        window.location.href = `/${sportcode}/Team?id=${event.target.value}`;

    };

    const onOppChange = (e, opps) => {        
        setOpps(opps);
    }

    const onSeasonChange = (e, seasons) => {        
        setSeasons(seasons);
    }

    const onLocationChange = (loc) => {        
        setLocation(loc)
    }

    useEffect(() => {
        async function fetchData() {
            const resp = await fetch(`/${sportcode}/Teams`, {
                method: 'POST'
            });
            const result = await resp.json();

            if (result) {

                setTeamOptions(result.map((team => { return { value: team.id, text: team.name, srid: team.srid, tmName: team.name, color1: team.color1, color2: team.color2, projected_wins: team.projected_wins } })));

                if (teamid) {

                    let tm = result.find(function (el) {
                        return el.id == teamid
                    });
                    if (tm) {
                        setTeamName(tm.market + ' ' + tm.name);
                        setSelTeam(tm)
                        setProjectedWins(tm.projected_wins)
                        //setSrid(tm.srid)
                        //setTmName(tm.name)
                    }

                }
            }


            setLoading(false);
        }

        fetchData();
    }, [sportcode]);

    return (
        <>
            {
                loading ? (
                    <Spinner className="mx-auto d-block">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>) : (


                    <>


                        {
                            teamid ? (

                                <>
                                    <div className="row m-2">

                                            <div className="col-12 col-xl-4 align-self-center">

                                            <FormControl className="d-flex flex-column justify-content-start mx-0" sx={{ m: 1, width: 300 }}>

                                                <Form.Select aria-label="Default select" size="md" value={teamid}
                                                    onChange={(e) => onTeamChange(e)}
                                                >

                                                    <option value="0">Select Team</option>

                                                    {teamOptions.map((i, index) => (
                                                        <option
                                                            key={i.value}
                                                            value={i.value}
                                                            srid={i.srid}
                                                        >
                                                            {i.text}
                                                        </option>
                                                    ))}

                                                </Form.Select>

                                            </FormControl>

                                        </div>

                                            <div className="col-12 col-xl-4 align-self-center">
                                            <h1 className="text-center h1-64 span-b64 text-blue-nv1 text-capitalize fs-1 m-3">{teamName}</h1>
                                        </div>

                                            <div className="col-12 col-xl-4 align-self-center">
                                        </div>

                                    </div>

                                    <div className="row m-2">

                                        <div className="col-12 col-xl-4">
                                            <div className="card">

                                                <div className="card-header">
                                                    <h3 className="text-center">Team Strength & Weaknesses</h3>
                                                </div>

                                                <div className="card-body">

                                                    <TeamInsightRG_MLB
                                                        teamid={teamid} firstTeam={selTeam}
                                                        teamOptions={teamOptions}
                                                    />

                                                </div>

                                            </div>

                                        </div>

                                        <div className="col-12 col-xl-4">

                                            <div className="card">

                                                <div className="card-header">
                                                    <h3 className="text-center">Win-Loss Summary</h3>
                                                </div>

                                                <div className="card-body">

                                                    <div className="row">

                                                        <div className="col-12 d-flex">

                                                            <WLoptions
                                                                    sportcode={sportcode}
                                                                    onOppChange={onOppChange}
                                                                    onSeasonChange={onSeasonChange}
                                                                    defaultSeasons={[getCurrentYear.toString()]}
                                                                    teamid={teamid}
                                                                    onLocationChange={onLocationChange}
                                                                    location={location}
                                                            ></WLoptions>

                                                        </div>

                                                        <div className="col-12">

                                                            <WLTable
                                                                teams={teams}
                                                                opps={opps}
                                                                seasons={seasons}
                                                                sportcode={sportcode}
                                                                    location={location}
                                                                    teamid={teamid}
                                                                    location={location}
                                                            ></WLTable>


                                                        </div>

                                                    </div>

                                                    <div className="row">

                                                        <WLChart
                                                                google={google}
                                                                teams={teams}
                                                                opps={opps}
                                                                seasons={seasons}
                                                                sportcode={sportcode}
                                                                location={location}
                                                                teamid={ teamid }
                                                        ></WLChart>

                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                        <div className="col-12 col-xl-4">

                                            <PickPropCard
                                                sportcode={sportcode}
                                                teamid={teamid}
                                                projected_wins={projedtedWins}
                                            ></PickPropCard>

                                        </div>

                                    </div>

                                </>

                            ) : ""
                        }

                    </>

                )
            }
        </>
    );
}

export default MLBTeamPage